import { defineStore } from "pinia"
import { type Ref, ref } from "vue"
import type { RouteLocationNormalized } from "vue-router"

export const usePendingRoute = defineStore('pendingRoute', () => {
  const __pendingRoute: Ref<undefined | RouteLocationNormalized> = ref(undefined)

  const toOriginalRoute = (targetRoute: RouteLocationNormalized) => {
    if (targetRoute.redirectedFrom) return targetRoute.redirectedFrom
    return targetRoute
  }

  const setPendingRoute = (targetRoute?: RouteLocationNormalized) => {
    if (!targetRoute) {
      __pendingRoute.value = undefined
      return
    }
    __pendingRoute.value = toOriginalRoute(targetRoute)
  }

  const getPendingRoute = (targetRoute?: RouteLocationNormalized) => {
    if (!__pendingRoute.value) {
      if (targetRoute) {
        return toOriginalRoute(targetRoute)
      }
      return { name: 'ConstructionList' } as RouteLocationNormalized
    }

    const curPendingRoute = { ...__pendingRoute.value }
    __pendingRoute.value = undefined
    return curPendingRoute
  }

  return {
    __pendingRoute,
    setPendingRoute,
    getPendingRoute,
  }
})